import { Controller } from '@hotwired/stimulus';

/** Save control: hidden until the form differs from its initial snapshot; then primary + pulsing halo + sticky bar. */
export default class extends Controller {
  static targets = ['submit', 'halo', 'cancel', 'bar'];

  connect() {
    this.captureInitial();
    this.render();
  }

  disconnect() {
    this.element.classList.remove('dirty-save-active');
  }

  check() {
    this.render();
  }

  reset() {
    this.captureInitial();
    this.render();
  }

  captureInitial() {
    this.initial = this.serialize();
  }

  serialize() {
    return new URLSearchParams(new FormData(this.element)).toString();
  }

  render() {
    const dirty = this.serialize() !== this.initial;

    this.element.classList.toggle('dirty-save-active', dirty);

    if (this.hasSubmitTarget) {
      this.submitTargets.forEach((btn) => this.styleSubmit(btn, dirty));

      if (this.hasHaloTarget) {
        const h = this.haloTarget;
        h.hidden = !dirty;
        h.classList.toggle('opacity-0', !dirty);
        h.classList.toggle('opacity-100', dirty);
        h.classList.toggle('ring-2', dirty);
        h.classList.toggle('ring-emerald-400/75', dirty);
        h.classList.toggle('animate-pulse', dirty);
      }
    }

    if (this.hasCancelTarget) {
      const hideCancel = this.hasSubmitTarget ? !dirty : false;
      this.cancelTargets.forEach((el) => {
        el.hidden = hideCancel;
      });
    }

    if (this.hasBarTarget) {
      this.barTarget.hidden = !dirty;
    }
  }

  styleSubmit(btn, dirty) {
    btn.hidden = !dirty;
    btn.disabled = !dirty;

    btn.classList.toggle('bg-emerald-50', !dirty);
    btn.classList.toggle('text-emerald-800', !dirty);
    btn.classList.toggle('border-emerald-200/90', !dirty);
    btn.classList.toggle('shadow-sm', !dirty);
    btn.classList.toggle('cursor-not-allowed', !dirty);

    btn.classList.toggle('bg-emerald-700', dirty);
    btn.classList.toggle('text-emerald-50', dirty);
    btn.classList.toggle('border-emerald-600', dirty);
    btn.classList.toggle('hover:bg-emerald-800', dirty);
    btn.classList.toggle('cursor-pointer', dirty);
    btn.classList.toggle('shadow-md', dirty);
  }
}
